<template>
  <div class="carousel">
    <div class="carousel_stage">
      <img :src="current.src" :alt="current.alt" loading="lazy" />

      <button class="carousel_arrow carousel_arrow--prev" type="button" aria-label="Poprzednie zdjęcie" @click="step(-1)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M15 5l-7 7 7 7" />
        </svg>
      </button>

      <button class="carousel_arrow carousel_arrow--next" type="button" aria-label="Następne zdjęcie" @click="step(1)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>

    <ul class="carousel_thumbs">
      <li v-for="(slide, i) in slides" :key="slide.src">
        <button
          type="button"
          :class="{ is_active: i === index }"
          :aria-label="`Zdjęcie ${i + 1}`"
          :aria-current="i === index"
          @click="index = i"
        >
          <img :src="slide.src" :alt="slide.alt" loading="lazy" />
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
// Photo gallery: one large image with arrows, and a thumbnail strip below.
// `slides` is [{ src, alt }].

export default {
  name: 'SiteCarousel',

  props: {
    slides: { type: Array, required: true },
  },

  data() {
    return { index: 0 }
  },

  computed: {
    current() {
      return this.slides[this.index]
    },
  },

  methods: {
    step(direction) {
      const count = this.slides.length
      this.index = (this.index + direction + count) % count
    },
  },
}
</script>

<style scoped>
.carousel_stage {
  position: relative;
  margin-bottom: 10px;
  border-radius: var(--radius);
  overflow: hidden;
}

.carousel_stage img {
  display: block;
  width: 100%;
  aspect-ratio: 850 / 478;
  object-fit: cover;
}

.carousel_arrow {
  position: absolute;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  transform: translateY(-50%);
  cursor: pointer;
}

.carousel_arrow svg {
  width: 18px;
  height: 18px;
}

.carousel_arrow--prev { left: 8px; }
.carousel_arrow--next { right: 8px; }

.carousel_thumbs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.carousel_thumbs li {
  flex: none;
}

.carousel_thumbs button {
  display: block;
  padding: 0;
  border: 3px solid transparent;
  border-radius: calc(var(--radius) + 3px);
  background: none;
  cursor: pointer;
}

.carousel_thumbs button.is_active {
  border-color: var(--ink);
}

.carousel_thumbs img {
  display: block;
  width: 129px;
  height: 86px;
  border-radius: var(--radius);
  object-fit: cover;
}
</style>
